<template>
  <v-row
    v-if="visible"
    no-gutters
    class="mb-2"
  >
    <v-col cols="3">
      <div
        class="pa-2 ml-2"
        style="font-size: 12.8px;"
      >
        予測候補
      </div>
    </v-col>
    <v-col cols="9">
      <div
        class="mt-1"
        style="color: #999; font-size: small; display: flex; flex-direction: column;"
      >
        <a
          v-for="branch in candidates"
          :key="branch.name"
          class="c-icd10-candidate"
          @click="$emit('select', branch.name)"
        >
          {{ branch.name }}
        </a>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Icd10CandidatesPanel",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    candidates: {
      type: Array,
      default: () => []
    }
  },
  emits: ["select"]
};
</script>

<style lang="scss">
.c-icd10-candidate {
  text-decoration: underline;
  color: #999 !important;
}
</style>
